
export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
